import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ModuleLayout from "../../layout/ModuleLayout";
import { useTranslation } from "react-i18next";
import {
  FaLayerGroup,
  FaPlus,
  FaList,
  FaCalculator,
  FaFilePdf
} from "react-icons/fa";
import DalaFormPage from "../Dala/DalaFormPage";
import DalaListPage from "../Dala/DalaListPage";
import DalaDetailsPage from "../Dala/DalaDetailsPage";

/* ===============================
   PAGES
=============================== */


const DalaModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: "dala",
    title: t("modules.dala.title"),
    description: t("modules.dala.description"),
    icon: FaLayerGroup,
    color: "#0d6efd",
    menuItems: [
      {
        path: "/dala-module/list",
        icon: FaList,
        label: t("nav.dalaList")
      }
    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        {/* Default */}
        <Route path="/" element={<Navigate to="/dala-module/list" replace />} />

        {/* Pages */}
        <Route path="/new" element={<DalaFormPage />} />
        <Route path="/list" element={<DalaListPage />} />
        <Route path="/edit/:id" element={<DalaFormPage />} />
      </Routes>
    </ModuleLayout>
  );
};

export default DalaModule;
